import React from 'react';
import styled from 'styled-components';
import Logo from '../assets/logo.svg';
import Logo1 from '../assets/logo-partouche-multiverse.png';
import Logo2 from '../assets/logo-partouche-multiverse.png';
import Logo3 from '../assets/logo-partouche-multiverse.png';
import Logo4 from '../assets/logo-partouche-multiverse.png';
import Logo5 from '../assets/logo-partouche-multiverse.png';


const PageWrapper = styled.div`
  background-color: #000;
  padding-bottom: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.p`
  color: #fff;
  align-self: flex-start;
  margin: 4rem;
  font-size: 6rem;
  font-family: 'MongoGrotesqueLight', sans-serif;

  @media (max-width: 900px) {
    font-size: 5rem;
    margin: 2rem;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
    }
`;

const SquaresWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex: 1;

  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    width: 100%;
    padding: 0 2rem;
  }
`;

const Square = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }
`;

const LogoIcon = styled.img`
  width: 40%;
  height: 30%;

`;

const ComingSoonOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-family: 'MongoGrotesqueLight', sans-serif;
  font-size: 2rem;
  color: #fff;
  z-index: 1;

  @media (max-width: 900px) {
    font-size: 1.2rem;
  }
`;

const Partenaire = () => {
  const logos = [Logo1, Logo2, Logo3, Logo4, Logo5];
  return (
    <PageWrapper>
    <Title>NOS PARTENAIRES</Title>
    <SquaresWrapper>
    {logos.map((logo, i) => (
      <Square key={i}>
        <LogoIcon src={logo} alt={`Partenaire ${i + 1}`} />
      </Square>
    ))}
  </SquaresWrapper>
    </PageWrapper>
  );
};

export default Partenaire;
